import React from "react";

 const SchedulerContext = React.createContext();

  export default SchedulerContext;